interface Props {
  title?: string;
  children: React.ReactNode;
}
/**
 * Card component to display content in a styled container.
 * used in the ExtensionMainModal component.
 * used in the ApproveSuspensionInfo component.
 * @param param0
 * @returns
 */
const Card = ({ title, children }: Props) => {
  return (
    <div className="w-full rounded-md border border-neutral-quiet bg-neutral-object-accent-silent p-2 leading-2xl">
      <p className="pb-1 text-sm font-body-bold text-body-loud ">{title}</p>
      {children}
    </div>
  );
};

export default Card;
